module.exports = __webpack_public_path__ + "static/undraw_development_ouy3-e991e3894f9bd2ee228cabe795a77222.svg";